import { render, staticRenderFns } from "./ListLiveAlertContactTable.vue?vue&type=template&id=521bd6b5"
import script from "./ListLiveAlertContactTable.vue?vue&type=script&lang=js"
export * from "./ListLiveAlertContactTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports